import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import { renderUyeliklerGrid } from "../uyeliklerGrid.js";
import { uiState } from "../../../state/uiState.js";

const API = "/api";
let didBind = false;

function ensureUyeliklerDeleteDialog() {
    if (document.getElementById("uyeliklerDeleteDialog")) return;
    document.body.insertAdjacentHTML("beforeend", `
<dialog id="uyeliklerDeleteDialog">
    <div class="delete-dialog-container">
        <div class="delete-dialog-header">
            <div class="delete-header-icon" style="background:#fee2e2">
                <span class="material-icons" style="font-size:22px;color:#ef4444">no_accounts</span>
            </div>
            <h2>Üyeliği Sil</h2>
            <button class="delete-dialog-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
        <hr class="delete-divider" />
        <div class="delete-dialog-body">
            <p>Aşağıdaki kişinin üyeliğini silmek istediğinizden emin misiniz?</p>
            <div class="delete-dialog-card">
                <div class="delete-card-icon">
                    <span class="material-icons" style="font-size:20px;color:#6b7280">manage_accounts</span>
                </div>
                <div class="delete-card-info">
                    <span class="delete-dialog-name uyelikler-delete-name"></span>
                </div>
            </div>
            <div class="delete-dialog-warning">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:1px">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                <span>Bu işlem geri alınamaz. Kişi kaydı silinmez, yalnızca sisteme giriş yetkisi kaldırılır.</span>
            </div>
        </div>
        <div class="delete-dialog-footer">
            <button class="delete-cancel">İptal</button>
            <button class="delete-confirm">
                <span class="material-icons" style="font-size:16px">no_accounts</span>
                Üyeliği Sil
            </button>
        </div>
    </div>
</dialog>`);
}

export function initUyeliklerDeleteDialog() {
    ensureUyeliklerDeleteDialog();
    const dialog = document.querySelector("#uyeliklerDeleteDialog");
    if (!dialog) return;
    if (didBind) return;
    didBind = true;

    let pendingId = null;

    window.openUyeliklerDeleteDialog = (id, label) => {
        pendingId = id;
        dialog.querySelector(".uyelikler-delete-name").textContent = label ?? "";
        dialog.showModal();
    };

    dialog.addEventListener("click", (e) => {
        if (e.target.closest(".delete-dialog-close") || e.target.closest(".delete-cancel")) {
            dialog.close();
        }
    });

    dialog.querySelector(".delete-confirm").addEventListener("click", async () => {
        if (!pendingId) return;
        const id = pendingId;

        showDialogOverlay(dialog, "Siliniyor...");
        await new Promise((r) => setTimeout(r, 350));
        try {
            const res = await fetch(`${API}/uyeler/${encodeURIComponent(id)}`, {
                method: "DELETE",
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            dialog.close();
            Toastify({
                text: "Üyelik silindi.",
                duration: 3000,
                gravity: "top",
                position: "right",
                style: { background: "#22c55e", borderRadius: "8px", fontSize: "14px", fontWeight: "500" },
            }).showToast();

            const refreshUrl = uiState.uyelikler.lastSearchUrl ?? `${API}/uyeler`;
            renderUyeliklerGrid({ url: refreshUrl, paginationLimit: uiState.uyelikler.paginationLimit });
        } catch (err) {
            console.error("❌ Üyelik silme hatası:", err);
            Toastify({
                text: "İşlem sırasında hata oluştu.",
                duration: 3000,
                gravity: "top",
                position: "right",
                style: { background: "#ee4447", borderRadius: "8px", fontSize: "14px", fontWeight: "500" },
            }).showToast();
        } finally {
            hideDialogOverlay();
        }
    });
}
